export const serviceDomain = "school-ai";
